import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom"; // Added Link
import { Helmet } from "react-helmet-async";
import { GiFairyWings } from "react-icons/gi";
import { FaArrowLeft } from "react-icons/fa"; // Added FaArrowLeft
import "./NewsDetail.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

function NewsDetail() {
  const { slug } = useParams();
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/news/slug/${slug}`);
        const data = await response.json();
        setNews(data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [slug]);

  if (loading) {
    return (
      <div className="news-details-loading">
        Loading...
      </div>
    );
  }

  if (!news) return null;

  let blocks = [];
  try {
    blocks = JSON.parse(news.contentBlocks || "[]");
  } catch (e) {
    console.log(e);
  }

  return (
    <>
      <Helmet>
        <title>{news.title}</title>
        <meta
          name="description"
          content="Latest news and announcements from Rajput Shiksha Kosh."
        />
      </Helmet>

      <div className="news-details-wrapper">
        <div className="news-details-container">
          
          {/* BACK BUTTON */}
          <div className="news-details-back-wrapper">
            <Link to="/news" className="news-details-styled-btn">
              <FaArrowLeft className="news-details-btn-icon" /> Back to News
            </Link>
          </div>

          {/* HEADER */}
          <div className="news-details-header">
            <h1>{news.title}</h1>
            <div className="news-details-divider">
              <span></span>
              <GiFairyWings />
              <span></span>
            </div>
            <p className="news-publish-date">
              Published on {new Date(news.publishDate).toLocaleDateString()}
            </p>
          </div>

          {/* COVER IMAGE */}
          {news.image && (
            <div className="news-details-cover-wrapper">
              <img
                src={`${API_BASE_URL}${news.image}`}
                alt={news.title}
                className="news-details-cover-image"
              />
            </div>
          )}

          {/* CONTENT BODY WRAPPER */}
          <div className="news-details-body">
            {blocks.map((block, index) => {
              
              if (block.type === "text") {
                return (
                  <div
                    key={index}
                    className="news-details-text"
                    dangerouslySetInnerHTML={{
                      __html: block.content,
                    }}
                  />
                );
              }

              if (block.type === "image") {
                const images = block.imageUrls || [];
                return (
                  <div
                    key={index}
                    className={`news-gallery count-${images.length}`}
                  >
                    {images.map((img, i) => (
                      <div key={i} className="news-gallery-item">
                        <img
                          src={`${API_BASE_URL}${img}`}
                          alt="News Gallery"
                        />
                      </div>
                    ))}
                  </div>
                );
              }

              return null;
            })}
          </div>

        </div>
      </div>
    </>
  );
}

export default NewsDetail;